import { h } from 'preact';
import { useThreekit } from '../threekit-context';
import { getImageAndTextConfigurations } from '../utils';

const ChangeConfiguration = ({
  configId,
  configuration,
  element,
  className,
  children,
  additionalOnClick,
}) => {
  const {
    configurator,
    setConfiguration,
    authToken,
    env,
    setFrontImage,
    setFrontCustomImage,
    setBackCustomImage,
    setBackImage,
    setFrontTextLine1,
    setFrontTextLine2,
    setBackTextLine1,
    setBackTextLine2,
  } = useThreekit();
  const Component = element || 'button';

  const handleButtonClick = async () => {
    if (additionalOnClick) additionalOnClick();
    if (configId) {
      const response = await fetch(
        `https://${env}.threekit.com/api/configurations/${configId}?bearer_token=${authToken}`,
      );
      const data = await response.json();
      const configuration = data.variant;

      // Remove animation/transition from configuration
      const keysToDelete = [
        '3D Animations',
        'Camera Views',
        'Change camera',
        'Mobile View Orientation',
        'Camera',
      ];

      keysToDelete.forEach((key) => {
        if (key in configuration) delete configuration[key];
      });

      // Set states of any images/texts
      const {
        frontImage,
        frontCustomImage,
        frontPattern,
        customArt,
        backImage,
        backCustomImage,
        backPattern,
        frontTextLine1,
        frontTextLine2,
        backTextLine1,
        backTextLine2,
      } = getImageAndTextConfigurations(configuration);

      setFrontImage(frontImage || frontPattern || customArt);
      setFrontCustomImage(frontCustomImage);
      setBackCustomImage(backCustomImage);
      setBackImage(backImage || backPattern);
      setFrontTextLine1(frontTextLine1);
      setFrontTextLine2(frontTextLine2);
      setBackTextLine1(backTextLine1);
      setBackTextLine2(backTextLine2);

      configurator.setConfiguration(configuration);
      setConfiguration(configuration);
      return;
    }

    configurator.setConfiguration(configuration);
    setConfiguration(configuration);
  };

  return (
    <Component className={className} onClick={() => handleButtonClick()}>
      {children}
    </Component>
  );
};

export default ChangeConfiguration;
